// Generated by CoffeeScript 2.7.0
var FieldMixin;

export default FieldMixin = {
  props: {
    field: {
      type: Object
    },
    entries: {
      type: Array,
      default: function() {
        return [];
      }
    },
    response: {
      type: Object
    },
    isAdmin: {
      type: Boolean
    }
  },
  data: function() {
    return {
      value: null,
      errors: []
    };
  },
  created: function() {
    this._parseEntriesToValue(this._initDefaultEntries(this.entries));
    this.$emit('childAdded', this);
    return this.$nextTick(function() {
      return typeof this.handleLogic === "function" ? this.handleLogic(true) : void 0;
    });
  },
  computed: {
    valid: function() {
      return !this.visible || !this.errors.length;
    },
    errorMsg: function() {
      return (_.first(this.errors)) || '';
    },
    valuePresent: function() {
      return Boolean(this.value);
    },
    // 返回给计算字段用的值
    valueForCalculation: function() {
      return {
        type: 'Text',
        value: this.value
      };
    }
  },
  methods: {
    valueChange: function(newValue) {
      this.value = newValue;
      if (typeof this.handleLogic === "function") {
        this.handleLogic();
      }
      this.validate();
      return this.$emit('valueChange', this);
    },
    destroyValue: function() {
      if (this.value) {
        return this.valueChange(null);
      }
    },
    validatePresence: function() {
      if (this.field.validations.indexOf('presence') === -1) {
        return true;
      }
      if (!this.valuePresent) {
        return this._addError('不能为空');
      }
    },
    validate: function() {
      this._resetValid();
      // 用户禁填的字段不参与校验（前提是该用户不是管理员，如果是管理员，则能参与校验，且能填）
      if (this.field.visibility === 'protected_visibility' && !this.isAdmin) {
        return;
      }
      return this._validate();
    },
    // 保存草稿箱时 validate_ignore 为 true
    getEntries: function(validate_ignore = false) {
      if (!this.visible) {
        return [];
      }
      if (!validate_ignore) {
        this.validate();
      }
      return this._parseValueToEntries(validate_ignore);
    },
    getResetEntries: function() {
      if (this.field.value_cache && this.value) {
        return this._parseValueToEntries();
      } else {
        return [];
      }
    },
    validChange: function(newValue) {
      return this.$emit('validChange', newValue);
    },
    reset: function() {
      this._resetValid();
      if (this.field.value_cache) {
        return;
      }
      this._clearValue();
      return this._updateChildView();
    },
    focusToCurrent: function() {
      this._positionToCurrent();
      return this._focus();
    },
    _positionToCurrent: function() {
      var body, el, offset;
      el = this.$el;
      body = document.body;
      offset = el.offsetTop;
      while (el.offsetParent && (el.offsetParent !== body)) {
        el = el.offsetParent;
        offset += el.offsetTop;
      }
      return body.scrollTop = offset;
    },
    _focus: function() {},
    _validate: function() {
      return this.validatePresence();
    },
    _resetValid: function() {
      return this.errors = [];
    },
    _addError: function(value) {
      return this.errors.push(value);
    },
    _clearValue: function() {
      return this._parseEntriesToValue(this._initDefaultEntries([]));
    },
    _parseEntriesToValue: function(entries) {
      return this.value = entries;
    },
    _parseValueToEntries: function() {
      var _result, result;
      _result = [];
      if (this.value) {
        if (this.entries.length) {
          result = _.clone(this.entries[0]);
          result._destroy = false;
          result.value = this.value;
        } else {
          result = {
            value: this.value,
            field_id: this.field.id
          };
        }
      } else {
        if (this.entries.length && this.entries[0].id) {
          result = _.clone(this.entries[0]);
          result._destroy = true;
        }
      }
      if (result) {
        _result.push(result);
      }
      return _result;
    },
    _initDefaultEntries: function(entries) {
      return entries;
    },
    _updateChildView: function() {}
  }
};
